module.exports = __webpack_public_path__ + "public/img/icon_liucun.d7f29450.png";